import { render } from "./GenresList.vue?vue&type=template&id=3573037a&scoped=true"
import script from "./GenresList.vue?vue&type=script&lang=js"
export * from "./GenresList.vue?vue&type=script&lang=js"

import "./GenresList.vue?vue&type=style&index=0&id=3573037a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3573037a"]])

export default __exports__